import React, {FunctionComponent} from "react";
import Dialog from '@material-ui/core/Dialog';
import '../style/loading.scss';

interface Props {
    [key: string]: any;
}

const loadImg= require('../img/loading.gif');

const Loading: FunctionComponent<Props> = (props) => {
    return (
        <Dialog className="loading-dialog" aria-labelledby="customized-dialog-title" open={true}>
            <img src={loadImg} alt=""/>
        </Dialog>
    )
}
export default Loading;
